import { render, staticRenderFns } from "./detail-apport-mobile.vue?vue&type=template&id=6a7fa6a0&scoped=true"
import script from "./detail-apport-mobile.vue?vue&type=script&lang=js"
export * from "./detail-apport-mobile.vue?vue&type=script&lang=js"
import style0 from "./detail-apport-mobile.vue?vue&type=style&index=0&id=6a7fa6a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fa6a0",
  null
  
)

export default component.exports